
import { defineComponent } from 'vue';
import BroadcastDisplayComponent from '@/components/BroadcastDisplayComponent.vue';

export default defineComponent({
	components: { BroadcastDisplayComponent },
});
